export default __webpack_public_path__ + "static/media/flag.1edd26d8.svg";